import React, { useState, useRef } from 'react';
// import Cropper from 'react-cropper';
import './cropper.css';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import ReactCrop from 'react-image-crop';
import { updateProfileImage } from '../../actions/userActions';
import LoadingView from '../Loader/LoadingView';

const ImageCroper = (props) =>
{
	const [ crop, setCrop ] = useState({
		unit   : '%', // Can be 'px' or '%'
		x      : 0,
		y      : 0,
		width  : 0,
		height : 0
	});
	const [ isLoading, setLoading ] = useState(false);

	const imageRef = useRef(null);

	const handleClose = () =>
	{
		props?.handleCancel();
	};

	const dataURLtoFile = (dataurl, filename) =>
	{

		const arr = dataurl.split(',');
		const bstr = atob(arr[1]);

		let n = bstr.length;
		const mime = arr[0].match(/:(.*?);/)[1],
			u8arr = new Uint8Array(n);

		while (n--)
		{
			u8arr[n] = bstr.charCodeAt(n);
		}

		return new File([ u8arr ], filename, { type: mime });
	};

	const getCroppedImg = (image, cropImg) =>
	{
		// eslint-disable-next-line no-console
		// console.log('image ===== ', image);
		const canvas = document.createElement('canvas');

		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;

		canvas.width = cropImg.width;
		canvas.height = cropImg.height;
		const ctx = canvas.getContext('2d');

		ctx.drawImage(
			image,
			cropImg.x * scaleX,
			cropImg.y * scaleY,
			cropImg.width * scaleX,
			cropImg.height * scaleY,
			0,
			0,
			cropImg.width,
			cropImg.height
		);
		const img = canvas.toDataURL();
		const imgfile = dataURLtoFile(img, 'pic.jpg');
		const formData = new FormData();

		formData.append('fileData', imgfile);

		return updateProfileImage(formData);
	};

	const makeClientCrop = async (cropImg) =>
	{
		if (!imageRef?.current) return;

		// If the user hit Save without drawing a crop box, save the full image.
		const finalCrop = (cropImg.width && cropImg.height)
			? cropImg
			: {
				x      : 0,
				y      : 0,
				width  : imageRef.current.width,
				height : imageRef.current.height
			};

		const response = await getCroppedImg(
			imageRef.current,
			finalCrop
		);

		setLoading(false);

		if (response?.data?.success)
		{
			props?.handleSetCroper();
		}
	};

	const onCropComplete = () =>
	{
		// eslint-disable-next-line no-console
		// console.log('isLoading ==== ', isLoading);
		setLoading(true);
		makeClientCrop(crop);
	};

	// eslint-disable-next-line no-console
	// console.log('isLoading ==== ', isLoading);

	return (
		<Dialog className='responsiveDialog'
			open={props?.isOpen}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
		>
			<DialogTitle id='scroll-dialog-title' className='dialogTitleBlock'>
				<div className='dialogHeaderBlock'>
					<div className='dialogHeaderText'>
						<h3>Crop Image</h3>

					</div>
				</div>
			</DialogTitle>
			<DialogContent className='dialogContent508'>
				{isLoading && <LoadingView />}
				{props.src && (
					<ReactCrop
						crop={crop}
						onChange={(c) => setCrop(c)}
						// onComplete={onCropComplete}
					>
						<img src={props.src} ref={imageRef} alt='crop'/>
					</ReactCrop>
				)}
			</DialogContent>
			<DialogActions className='dialogFooterBlock'>
				<Button size='small' onClick={handleClose} color='primary' disableElevation>
					Cancel
				</Button>
				<Button size='small' color='primary' onClick={onCropComplete} disableElevation>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ImageCroper;
